import * as authAPIS from './authAPI'
import { loadUserByToken, logout, setInitializationComplete } from './authSlice'
import crossTabLogout from '../../../../utils/crossTabLogout'

export const loadUserByTokenThunk = () => async (dispatch) => {
    try {
        const response = await authAPIS?.loadUserByToken()
        dispatch(loadUserByToken(response))
        dispatch(setInitializationComplete())
    } catch (error) {
        // Broadcast logout event to other tabs
        crossTabLogout.broadcastLogout()
        
        // Handle logout on token failure
        dispatch(logout())
        dispatch(setInitializationComplete())
    }
}
